/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate, Interpolate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class DisableAccountSuccess extends React.Component<*> {
  componentDidMount() {
    const accountStore = this.props.accountStore;

    if (accountStore.specificUser) {
      accountStore.specificUser.account_user_enabled = 0; // eslint-disable-line camelcase
    }
  }

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const account: Object = actionDrawerStore.response.account;
    const user: Object = actionDrawerStore.response.users[0];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:trading_accounts.access_disabled')}
          >
            <p>
              <Interpolate
                i18nKey="general:trading_accounts.messages.access_disabled"
                trading_account={account.name}
              />
            </p>
            <div className={styles['disable-account-details']}>
              <ul>
                <li>{`${user.first_name} ${user.last_name}`}</li>
                <li>
                  <b>{t('general:roles.labels.current_role')}</b>: {user.role}
                </li>
              </ul>
            </div>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
